import React from "react";
import { CrossIcon } from "@aureskonnect/react-ui";
import { CustomCardHeader } from "@components/Common/CustomCardStyled";

type ApplicationHeaderProps = {
    title: string;
    onClose: () => void;
};

export const ApplicationHeader: React.FC<ApplicationHeaderProps> = ({
    title,
    onClose,
}) => {
    return (
        <CustomCardHeader
            className="d-flex align-items-center justify-content-between"
            style={{ maxHeight: "76px" }}
        >
            <h5 className="pt-3">{title}</h5>
            <CrossIcon
                style={{ cursor: "pointer" }}
                height={13}
                width={13}
                onClick={onClose}
            />
        </CustomCardHeader>
    );
};
